import React from 'react'
import { SvgIcon } from '@mui/material'

export const ReportIcon = props => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'secondary.main' }} {...props}>
    <path
      d="M12 7a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1Zm0 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm9.71-7.44-5.27-5.27c-.2-.18-.45-.29-.71-.29H8.27c-.26 0-.52.1-.71.29L2.29 7.56c-.18.2-.29.45-.29.71v7.46c0 .26.1.52.29.71l5.27 5.27c.2.18.45.29.71.29h7.46c.26 0 .52-.1.71-.29l5.27-5.27c.18-.2.29-.45.29-.71V8.27c0-.26-.1-.52-.29-.71ZM20 15.31 15.31 20H8.69L4 15.31V8.69L8.69 4h6.62L20 8.69v6.62Z"
      fill="inherit"
    />
  </SvgIcon>
)
